import { gql } from '@apollo/client/core'

// Driver Queries
export const GET_DRIVERS = gql`
  query GetDrivers($userId: ID!) {
    drivers(userId: $userId) {
      id
      firstName
      lastName
      fullName
      email
      cpf
      phone
      rating
      status
      lat
      lng
      photo
      finishedRides
      lastRideAt
      lastOnlineAt
      classification
      acceptsCash
      car {
        brand
        model
        year
        color
        plate
        photo
        ipvaYear
        hasInsurance
      }
      driverData {
        birthDate
        address
        zip
        neighborhood
        city
        state
      }
      subscription {
        start
        end
        value
        restantDays
      }
      createdAt
      updatedAt
      isOnline
      hasValidLocation
      hasCompletedRides
      ratingDisplay
      hasSubscription
      lastUpdatedAt
      insuranceStatus
      ipvaDisplay
      formattedAddress
      cnhExpiresAt
    }
  }
`

export const GET_DRIVER = gql`
  query GetDriver($userId: ID!, $id: ID!) {
    driver(userId: $userId, id: $id) {
      id
      firstName
      lastName
      fullName
      email
      cpf
      phone
      rating
      status
      lat
      lng
      photo
      finishedRides
      lastOnlineAt
      lastRideAt
      classification
      acceptsCash
      car {
        brand
        model
        year
        color
        plate
        photo
        ipvaYear
        hasInsurance
      }
      driverData {
        birthDate
        address
        zip
        neighborhood
        city
        state
      }
      subscription {
        start
        end
        value
        restantDays
      }
      createdAt
      updatedAt
      isOnline
      hasValidLocation
      hasCompletedRides
      ratingDisplay
      hasSubscription
      lastUpdatedAt
      insuranceStatus
      ipvaDisplay
      formattedAddress
      cnhExpiresAt
    }
  }
`

export const GET_ONLINE_TIME = gql`
  query GetOnlineTime($driverId: ID!, $dateStart: String!, $dateEnd: String!) {
    onlineTime(driverId: $driverId, dateStart: $dateStart, dateEnd: $dateEnd) {
      tempoTotal
      diasOnline
      tempoMedioPorDia
      dataInicio
      dataFim
    }
  }
`

export const GET_DRIVER_AGGREGATES = gql`
  query GetDriverAggregates($userId: ID!) {
    driverAggregates(userId: $userId) {
      totalDrivers
      onlineDrivers
      offlineDrivers
      averageRating
      subscription
      onlinePercentage
      offlinePercentage
      lastUpdatedAt
    }
  }
`
